import React, { useEffect, useState } from 'react';
import { getLabExecutiveSummary } from '../api/smartiLabApi';
import LabCard from '../components/LabCard';
import LabEmptyState from '../components/LabEmptyState';
import LabMetric from '../components/LabMetric';
import SmartiLabBadge from '../components/SmartiLabBadge';
import { useSmartiLabContext } from '../SmartiLabContext';

export default function ExecutiveSummaryPage() {
  const { sharedQuery } = useSmartiLabContext();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    getLabExecutiveSummary(sharedQuery).then(setData).catch((loadError) => setError(loadError.message || 'Unable to load executive summary.'));
  }, [sharedQuery]);

  return (
    <div className="lab-page">
      <LabCard title="Executive summary" description="Simple language for managers: what got worse, what likely drives it, which stations need attention, and what actions are open.">
        {error ? <div className="lab-error-text">{error}</div> : null}
        {data ? (
          <>
            <div className="lab-metric-grid">
              <LabMetric label="Open actions" value={data.openActionCount ?? 0} />
              <LabMetric label="Linked serials" value={data.trust?.linkedSerialCount ?? 0} />
              <LabMetric label="Data blockers" value={data.trust?.dataQualityBlockers ?? 0} />
              <LabMetric label="Confidence" value={data.trust?.confidenceLevel || 'unknown'} />
            </div>
            <div className="lab-human-action-panel">
              <strong>What Smarti Lab says right now</strong>
              <p>{data.executiveMessage}</p>
            </div>
            <div className="lab-chip-row">
              {(data.attentionStations || []).filter(Boolean).slice(0, 8).map((station) => (
                <SmartiLabBadge key={station} variant="warning" label={station} />
              ))}
            </div>
            {data.topPriority ? (
              <div className="lab-human-action-panel">
                <strong>Top likely driver</strong>
                <p>{data.topPriority.title_en}</p>
                <p>{data.topPriority.short_explanation_en}</p>
              </div>
            ) : null}
          </>
        ) : (
          <LabEmptyState title="Executive summary unavailable" description="Run the fusion pipeline and refresh this page once Smarti Lab has current output." />
        )}
      </LabCard>
    </div>
  );
}
